import React, { useState } from 'react';
import axios from 'axios';
import '../styles/StoryUpload.css';

const StoryUpload = ({ onStoryCreated, onCancel }) => {
  const [file, setFile] = useState(null);
  const [text, setText] = useState('');
  const [preview, setPreview] = useState(null);
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem('token');

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
      // Show preview
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreview(reader.result);
      };
      reader.readAsDataURL(selectedFile);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!file) {
      alert('Выберите фото для истории');
      return;
    }

    try {
      setLoading(true);
      const formData = new FormData();
      formData.append('image', file);
      formData.append('text', text);

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/stories/upload`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      if (onStoryCreated) {
        onStoryCreated(response.data.story);
      }

      // Reset form
      setFile(null);
      setText('');
      setPreview(null);
      onCancel();
    } catch (err) {
      console.error('Error uploading story:', err);
      alert('Ошибка при загрузке истории');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="story-upload-modal">
      <div className="story-upload-container">
        <div className="story-upload-header">
          <h2>📸 Создать историю</h2>
          <button className="close-btn" onClick={onCancel}>✕</button>
        </div>

        <form onSubmit={handleSubmit} className="story-upload-form">
          {preview ? (
            <div className="preview-container">
              <div className="preview-image">
                {file.type.startsWith('image/') ? (
                  <img src={preview} alt="Preview" />
                ) : (
                  <video src={preview} controls />
                )}
              </div>
              <div className="preview-text">
                <textarea
                  value={text}
                  onChange={(e) => setText(e.target.value)}
                  placeholder="Добавить текст к истории (необязательно)..."
                  maxLength="200"
                />
                <div className="text-counter">{text.length}/200</div>
              </div>
            </div>
          ) : (
            <div className="upload-area">
              <label htmlFor="file-input" className="upload-label">
                <div className="upload-icon">📁</div>
                <div className="upload-text">
                  <div>Перетащите фото/видео сюда</div>
                  <div className="upload-hint">или кликните для выбора</div>
                </div>
              </label>
              <input
                id="file-input"
                type="file"
                accept="image/*,video/*"
                onChange={handleFileChange}
                className="file-input"
              />
            </div>
          )}

          <div className="story-upload-actions">
            <button
              type="button"
              className="cancel-btn"
              onClick={onCancel}
              disabled={loading}
            >
              Отмена
            </button>
            {preview && (
              <>
                <button
                  type="button"
                  className="change-btn"
                  onClick={() => {
                    setPreview(null);
                    setFile(null);
                    setText('');
                  }}
                  disabled={loading}
                >
                  Выбрать другое
                </button>
                <button
                  type="submit"
                  className="submit-btn"
                  disabled={loading}
                >
                  {loading ? 'Загрузка...' : 'Опубликовать историю'}
                </button>
              </>
            )}
          </div>
        </form>
      </div>
    </div>
  );
};

export default StoryUpload;
